module.exports = __webpack_public_path__ + "img/36.ce98f829.jpg";